module.exports = __webpack_public_path__ + "static/media/Futura-Medium.a8bb1c20.otf";